const attachmentFilesEquipmentModelsTypo = {
  label: 'Archivos adjuntos de tipo de equipo',
  noResults: 'Ningún resultado encontrado'
};

export default attachmentFilesEquipmentModelsTypo;
